module.exports = {
      id: "icon-episode-usage",
      viewBox: "0 0 25 25",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-episode",
      toString: function () {
        return this.url;
      }
    }